module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Mono-Bold.d19d680.woff";